<div class="flyout-panel">
  @if (!isLoading) {
    <h3 class="title">
      @if (activeTab && !editingTitle) {
        <button type="button" class="back-btn" (click)="activeTab = null; disableAllFilters()">
          <i class="fa fa-angle-left"></i>
        </button>
      }
      @if (!editingTitle) {
        {{ title }}
        <button type="button" class="edit-title-btn" (click)="editingTitle = true">
          <mat-icon>edit</mat-icon>
        </button>
      } @else {
        <input #titleInput [(ngModel)]="title" (blur)="saveTitle()" (keydown.enter)="saveTitle()" class="edit-title-input"
          autofocus />
        }
      </h3>
    }

    @if (isLoading) {
      <div class="loader-container">
        <app-rings-loader></app-rings-loader>
      </div>
    }

    <div class="content-wrapper">
      @if (!isLoading && !activeTab) {
        <div class="settings-switcher">
          <div class="switcher-row" (click)="activeTab = 'properties'">
            <img src="assets/images/properties.svg" alt="Properties Icon" class="icon" />
            <span class="switcher-label">{{"Properties" | translate}}</span>
            <span class="switcher-count">{{ visibleColumnCount }} {{"Shown" | translate}}</span>
            <mat-icon class="arrow">chevron_right</mat-icon>
          </div>
          @if (showFiltersTab) {
          <div class="switcher-row" (click)="activeTab = 'filters'">
            <img src="assets/images/filter.svg" alt="Filters Icon" class="icon" />
            <span class="switcher-label">{{"Filters" | translate}}</span>
            <span class="switcher-count">{{ activeFiltersCount }}</span>
            <mat-icon class="arrow">chevron_right</mat-icon>
          </div>
          }
          @if (showSortTab) {
          <div class="switcher-row" (click)="activeTab = 'sort'">
            <img src="assets/images/sort.svg" alt="Sort Icon" class="icon" />
            <span class="switcher-label">{{"Sort" | translate}}</span>
            <span class="switcher-count">{{ selectedSort?.sortBy ? 1 : 0 }}</span>
            <mat-icon class="arrow">chevron_right</mat-icon>
          </div>
          }
          @for (tab of extraTabs; track tab.key) {
            <div class="switcher-row" (click)="activeTab = tab.key">
              <img [src]="tab.icon" alt="" class="icon" />
              <span class="switcher-label">{{ tab.label | translate }}</span>
              <span class="switcher-count">{{ tab.count }}</span>
              <mat-icon class="arrow">chevron_right</mat-icon>
            </div>
          }
        </div>
      }

      <!-- PROPERTIES TAB -->
      @if (activeTab === 'properties') {
        <div class="search-container-filter">
          <app-search-input placeholder="{{'Search for columns...' | translate}}" [value]="searchQuery"
            (valueChange)="searchQuery = $event; onSearch()">
          </app-search-input>
        </div>
        <div class="settings-list" cdkDropList (cdkDropListDropped)="onDrop($event)"
          [cdkDropListDisabled]="!!searchQuery">
          @if (!searchQuery) {
            <div class="settings-item all-toggle">
              <div class="column-name all-name">{{"All" | translate}}</div>
              <mat-slide-toggle [checked]="areAllVisible()" (change)="toggleAll($event.checked)">
              </mat-slide-toggle>
            </div>
          }
          @for (column of filteredColumns; track trackByIndex(i); let i = $index) {
            <div class="settings-item" cdkDrag [class.hide-drag]="!!searchQuery">
              @if (!searchQuery) {
                <div class="drag-handle" cdkDragHandle>⋮⋮</div>
              }
              <div class="column-name">{{ displayNameByProperty.get(column.property) | translate}}</div>
              @if (!searchQuery && column.visible && column.isDisplayNameConfigurable && (!canFreezeColumn || canFreezeColumn.has(column.property))) {
                <button type="button" class="freeze-btn"
                  [class.frozen]="isColumnFrozen(column)"
                  (click)="toggleFreezeAtColumn(column)"
                  [matTooltip]="getFreezeTooltipKey(column) | translate"
                  [attr.aria-label]="getFreezeTooltipKey(column) | translate"
                  matTooltipPosition="left">
                  <mat-icon>ac_unit</mat-icon>
                </button>
              }
              <mat-slide-toggle [(ngModel)]="column.visible" (change)="toggleColumnVisibility(column)"
              [disabled]="column.disabled || !column.isDisplayNameConfigurable"></mat-slide-toggle>
              <ng-template cdkDragPreview>
                <div class="settings-item drag-preview">
                  <div class="drag-handle">⋮⋮</div>
                  <div class="column-name">{{ getDisplayName(column)| translate}}</div>
                </div>
              </ng-template>
              <ng-template cdkDragPlaceholder>
                <div class="settings-item drag-placeholder"></div>
              </ng-template>
            </div>
          }
        </div>
      }

      <!-- FILTERS TAB -->
      @if (activeTab === 'filters' && !isLoading) {
        <div class="filters-section">
          @if (quickFilters.length) {
            <div class="group-label">{{"Quick filters" | translate}}</div>
            <ng-container *ngTemplateOutlet="quickFilterRows"></ng-container>
            <div class="group-label">{{"Filters" | translate}}</div>
          }
          @if (filters.length === 0 && !hasActiveQuickFilters) {
            <div class="no-active-filters-msg">
              {{"No filters currently active" | translate}}
            </div>
          }
          @for (filter of filters; track trackByIndex(i); let i = $index) {
            <div class="filter-row">
              <!-- EDIT MODE -->
              @if (filter.isEditing) {
                @if (filterTypeFlagsByProperty.get(filter.column.property); as flags) {
                  <div class="filter-header"
                    [ngClass]="{ 'enum-filter': flags.isNumber || flags.isDate || flags.isEnum || flags.isObject || flags.isBoolean }">
                    <span class="filter-column">{{ displayNameByProperty.get(filter.column.property) | translate}}&nbsp;</span>
                    <span class="filter-operator-label">
                      @if (flags.isDate) {
                        <mat-form-field appearance="fill" class="filter-operator-select">
                          <mat-select class="filter-select" [(ngModel)]="filter.operator"
                            (selectionChange)="onOperatorChange(filter)">
                            @for (op of gridSettingsService.dateOperators; track trackByIndex($index)) {
                              <mat-option [value]="op.value">{{ op.label | translate
                              }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (flags.isNumber) {
                        <mat-form-field appearance="fill" class="filter-operator-select">
                          <mat-select class="filter-select" [(ngModel)]="filter.operator"
                            (selectionChange)="onOperatorChange(filter)">
                            @for (op of gridSettingsService.numberOperators; track trackByIndex($index)) {
                              <mat-option [value]="op.value">{{ op.label | translate
                              }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (flags.isString) {
                        <mat-form-field appearance="fill" class="filter-operator-select">
                          <mat-select class="filter-select" [(ngModel)]="filter.operator"
                            (selectionChange)="onOperatorChange(filter)">
                            @for (op of gridSettingsService.stringOperators; track trackByIndex($index)) {
                              <mat-option [value]="op.value">{{ op.label | translate
                              }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (flags.isEnum || flags.isObject || flags.isBoolean) {
                        <span>
                          <span class="enum-operator-label">{{"is" | translate}}</span>
                        </span>
                      }
                    </span>
                  </div>
                }
                <!-- FILTER TYPE -->
                <app-filter-type [filter]="filter" [separatorKeysCodes]="separatorKeysCodes"
                  [getFilteredOptions]="getFilteredOptions.bind(this)" [organizationLevels]="organizationLevelsHierarchical"
                  (filterChange)="filterChange($event)" (addChip)="addChip($event.event, $event.filter)"
                  (removeChip)="removeChip($event.filter, $event.chipIdx)"
                  (editChip)="editChip($event.filter, $event.chipIdx, $event.$event)">
                </app-filter-type>
              } @else {
                <div class="filter-chip-display">
                  <button class="filter-chip-btn" [matMenuTriggerFor]="filterActionMenu" [matMenuTriggerData]="{index: i}">
                    {{ displayNameByProperty.get(filter.column.property) | translate }}
                    <span class="operator-label">{{ getDisplayOperator(filter) }}</span>
                    @if (gridSettingsService.getDisplayValue(filter)) {
                      <span>{{ gridSettingsService.getDisplayValue(filter,
                        false)
                      }}</span>
                    }
                    <i class="fa fa-chevron-down"></i>
                  </button>
                  <mat-menu #filterActionMenu="matMenu">
                    <button mat-menu-item (click)="editFilter(i)">
                      <i class="fa fa-edit"></i> {{"Edit" | translate}}
                    </button>
                    <button mat-menu-item (click)="removeFilter(i)">
                      <i class="fa fa-trash"></i> {{"Delete" | translate}}
                    </button>
                  </mat-menu>
                </div>
              }
              <!-- DISPLAY MODE -->
            </div>
          }
          <button #filterMenuTrigger="matMenuTrigger" class="add-filter-btn" [matMenuTriggerFor]="filterMenu"
            (click)="openAddFilterMenu()">
            <mat-icon>add</mat-icon>
            {{"Add Filter" | translate}}
          </button>
          <mat-menu #filterMenu="matMenu" class="filter-menu" (closed)="onFilterMenuClosed()">
            <div class="filter-menu-content" (click)="$event.stopPropagation()">
              @if (quickFilters.length) {
                <div class="group-label">{{"Quick filters" | translate}}</div>
                <ng-container *ngTemplateOutlet="quickFilterRows"></ng-container>
                <hr />
                <div class="group-label">{{"Columns" | translate}}</div>
              }
              <div class="search-container-filter">
                <app-search-input #filterSearchInput placeholder="{{'Search columns...' | translate}}" [value]="filterSearchQuery"
                  (valueChange)="onFilterSearchInput($event)">
                </app-search-input>
              </div>
              <div class="filter-menu-options">
                @for (col of filteredFilterColumns; track trackByProperty($index, col)) {
                  <button mat-menu-item class="filter-menu-option"
                    (click)="selectFilterColumn(col)">
                    {{ displayNameByProperty.get(col.property) | translate}}
                  </button>
                }
                @if (filteredFilterColumns.length === 0) {
                  <div class="filter-menu-no-results">
                    {{"No columns found" | translate}}
                  </div>
                }
              </div>
            </div>
          </mat-menu>
          @if (!filterMenuOpen && (filters.length > 0 || hasActiveQuickFilters)) {
            <hr />
          }
          @if (!filterMenuOpen && (filters.length > 0 || hasActiveQuickFilters)) {
            <button class="reset-filters-btn" (click)="resetFilters()">
              <img src="assets/images/repeat.svg" alt="Reset Filters" class="reset-filters-img" />
              {{"Reset Filters" | translate}}
            </button>
          }
        </div>
      }

      @for (tab of extraTabs; track tab.key) {
        @if (activeTab === tab.key && !isLoading) {
          <ng-container *ngTemplateOutlet="tab.template"></ng-container>
        }
      }

      <!-- SORT TAB -->
      @if (activeTab === 'sort' && !isLoading) {
        <div class="filter-section">
          @if (!selectedSort) {
            <div class="no-active-filters-msg">{{"No sort currently active" | translate}}</div>
          }
          @if (selectedSort) {
            <div class="filter-display-row">
              <span class="filter-column-label">{{ getSortColumnDisplayName(selectedSort.sortBy) }}</span>
              <mat-form-field appearance="fill" class="sort-direction-select">
                <mat-select [(ngModel)]="selectedSort.sortOrder" (selectionChange)="onSortDirectionChange()">
                  <mat-option value="asc">{{"Ascending" | translate}}</mat-option>
                  <mat-option value="desc">{{"Descending" | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          }
          <button #sortMenuTrigger="matMenuTrigger" class="add-filter-btn add-sort-btn" [matMenuTriggerFor]="sortMenu"
            (click)="openAddSortMenu()">
            <mat-icon>{{ selectedSort ? 'edit' : 'add' }}</mat-icon>
            {{ selectedSort ? ('Edit Sort' | translate) : ('Add Sort' | translate) }}
          </button>
          <mat-menu #sortMenu="matMenu" class="filter-menu" (closed)="onSortMenuClosed()">
            <div class="filter-menu-content" (click)="$event.stopPropagation()">
              <div class="search-container-filter">
                <app-search-input #sortSearchInput placeholder="{{'Search columns...' | translate}}" [value]="sortSearchQuery"
                  (valueChange)="onSortSearchInput($event)">
                </app-search-input>
              </div>
              <div class="filter-menu-options">
                @for (col of filteredSortColumns; track trackByProperty($index, col)) {
                  <button mat-menu-item class="filter-menu-option"
                    (click)="selectSortColumn(col); sortMenuTrigger.closeMenu();"
                    [disabled]="selectedSort?.sortBy === col.property || col.property === actionColumnProperty || col.disabled || !col.isDisplayNameConfigurable">
                    {{ displayNameByProperty.get(col.property) | translate}}
                  </button>
                }
                @if (filteredSortColumns.length === 0) {
                  <div class="filter-menu-no-results">
                    {{"No columns found" | translate}}
                  </div>
                }
              </div>
            </div>
          </mat-menu>
        </div>
        <hr />
        <button class="delete-sort-btn" (click)="deleteSort()" [disabled]="!selectedSort"
          [ngClass]="{'disabled': !selectedSort}">
          <i class="fa fa-trash"></i> {{"Delete sort" | translate}}
        </button>
      }
    </div>

    @if (!isLoading) {
      <div class="share-view-section" [class.disabled]="!canManage" (click)="toggleShareView()">
        <mat-checkbox [(ngModel)]="shareView" [disabled]="!canManage" (change)="onShareToggle($event.checked)" (click)="$event.stopPropagation()">
          {{"Share View" | translate}}
        </mat-checkbox>
      </div>
    }

    @if (shareView && organizationLevels.length > 0 && !isLoading) {
      <div class="org-level-select-section global">
        <label class="org-level-label">{{"Visibility" | translate}}</label>
        <mat-form-field appearance="outline" class="org-level-select">
          <mat-select [(ngModel)]="selectedOrgLevelId">
            @for (orgLevel of organizationLevels; track trackById($index, orgLevel)) {
              <mat-option [value]="orgLevel.id">
                {{ orgLevel.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <div class="actions">
      <button class="btn modal-footer-btn save-modal-btn" (click)="onSave()"
        [disabled]="isLoading || !canSaveView || !canManage"
        [title]="!canSaveView ? (cannotSaveViewTooltip | translate) : ''">
        {{"Save" | translate}}
      </button>
      <button class="btn modal-footer-btn cancel-modal-btn" (click)="onClose()" [disabled]="isLoading">{{"Close" | translate}}</button>
    </div>
  </div>

  <ng-template #quickFilterRows>
    @for (quickFilter of quickFilters; track quickFilter.key) {
      <div class="quick-filter-row">
        <div class="quick-filter-text">
          <span class="quick-filter-label">{{ quickFilter.label | translate }}</span>
          <span class="quick-filter-description">{{ quickFilter.description | translate }}</span>
        </div>
        <mat-slide-toggle [checked]="quickFilterValues[quickFilter.key] !== undefined"
          (change)="quickFilterToggled.emit({ key: quickFilter.key, isOn: $event.checked })"></mat-slide-toggle>
      </div>
    }
  </ng-template>
